import type { DirectCallListener } from '../types';

export const noop = () => {
  void 0;
};
export const noopDirectCallListener: DirectCallListener = {
  onPropertyUpdatedManually: noop,
  onAudioDeviceChanged: noop,
  onConnected: noop,
  onCustomItemsDeleted: noop,
  onCustomItemsUpdated: noop,
  onEnded: noop,
  onEstablished: noop,
  onLocalVideoSettingsChanged: noop,
  onReconnected: noop,
  onReconnecting: noop,
  onRemoteAudioSettingsChanged: noop,
  onRemoteRecordingStatusChanged: noop,
  onRemoteVideoSettingsChanged: noop,
  onUserHoldStatusChanged: noop,
};
export const noopRoomListener = {
  onPropertyUpdatedManually: noop,
  onDeleted: noop,
  onError: noop,
  onRemoteParticipantEntered: noop,
  onRemoteParticipantExited: noop,
  onRemoteParticipantStreamStarted: noop,
  onAudioDeviceChanged: noop,
  onRemoteVideoSettingsChanged: noop,
  onRemoteAudioSettingsChanged: noop,
  onCustomItemsUpdated: noop,
  onCustomItemsDeleted: noop,
};
